import React, { useCallback, useEffect } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { AppNavigationOutlined } from 'assets/assetsV1/iconComponents';

import { Divider } from 'uiToolkitV1/Divider';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { SelectDashed } from 'uiToolkitV1/Select';

import { RecurrenceActions, useGoalRecurrenceDetails } from '../../Context/GoalRecurrenceDetailsProvider';
import { goalPreferencesActions, useGoalPreferencesContext } from '../context/GoalPreferencesProvider';

const FREQUENCY_OPTIONS = [
  { label: 'Quarterly', value: 'QUARTERLY' },
  { label: 'Half Yearly', value: 'HALF_YEARLY' },
  { label: 'Yearly', value: 'YEARLY' },
];

const WEEKDAYS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 0, label: 'Sunday' },
];

const INSTANCE_PERIOD = [
  { value: 0, label: 'First' },
  { value: 1, label: 'Second' },
  { value: 2, label: 'Third' },
  { value: 3, label: 'Fourth' },
  // { value: 4, label: 'Last' },
];

const CHECKIN_REMINDER_FREQUENCY = [
  {
    value: 'NONE',
    label: 'None',
  },
  {
    value: 'WEEK',
    label: 'Weekly',
  },
  {
    value: 'FORTNIGHTLY',
    label: 'Fortnightly',
  },
  {
    value: 'MONTH',
    label: 'Monthly',
  },
];

const DAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

const CheckinReminder = () => {
  const { state, recurrenceText, reset, submit, loading, recurrenceDispatch, getFinalValue } =
    useGoalRecurrenceDetails();

  const { goalPreferenceDispatch } = useGoalPreferencesContext();

  const saveCheckinReminderData = () => {
    goalPreferenceDispatch({
      type: goalPreferencesActions.SET_CHECKIN_REMINDER_DETAILS,
      payload: {
        data: getFinalValue(),
      },
    });
  };

  useEffect(() => {
    saveCheckinReminderData();
  }, [state]);

  const { recurrencePeriod, weeklyRecurrenceDetails, monthlyRecurrenceDetails } = state;

  const changeWeekday = useCallback(
    (idx) => {
      recurrenceDispatch({
        type: RecurrenceActions.UPDATE_WEEKLY_RECURRENCE_DAY,
        payload: {
          day: idx,
        },
      });
    },
    [recurrenceDispatch]
  );

  const changeRecurrencePeriod = useCallback(
    (periodObj) => {
      recurrenceDispatch({
        type: RecurrenceActions.UPDATE_RECURRENCE_PERIOD,
        payload: {
          period: periodObj.id,
        },
      });
    },
    [recurrenceDispatch]
  );

  const changeMonthlyRecurrenceDetails = useCallback((type, value) => {
    switch (type) {
      case 'recurrenceType':
        recurrenceDispatch({
          type: RecurrenceActions.UPDATE_MONTHLY_RECURRENCE_TYPE,
          payload: {
            recurrenceType: value,
          },
        });
        break;
      case 'dayOfMonth':
        recurrenceDispatch({
          type: RecurrenceActions.UPDATE_MONTHLY_RECURRENCE_DAY_OF_MONTH,
          payload: {
            dayOfMonth: value,
          },
        });
        break;
      case 'dayOfWeek':
        recurrenceDispatch({
          type: RecurrenceActions.UPDATE_MONTHLY_RECURRENCE_DAY_OF_WEEK,
          payload: {
            dayOfWeek: value,
          },
        });
        break;
      case 'weekNumber':
        recurrenceDispatch({
          type: RecurrenceActions.UPDATE_MONTHLY_RECURRENCE_WEEK_NUMBER,
          payload: {
            weekNumber: value,
          },
        });
        break;
    }
  });

  return (
    <>
      <Box bgColor="white" padding="2rem" borderRadius={8}>
        <Box mb="1rem">
          <Flex justifyContent="space-between" alignItems="center">
            <ListItemComp
              withoutBackground
              LeftComponent={AppNavigationOutlined}
              title="Check-in Reminders"
              subTitle="Choose how frequently check-in reminders should be sent"
              p={0}
              px={1}
            />
          </Flex>
        </Box>
        <Divider />

        <Box mb="2rem">
          {/* <Typography14 style={{ fontWeight: '400', fontSize: '14px', padding: '1rem 0' }}>
            Goals checkin reminder frequency
          </Typography14> */}

          <Flex columnGap={8}>
            <SelectDashed
              handleChange={(obj) => {
                changeRecurrencePeriod({ id: obj.value });

                // ADDED THIS TO ENABLE FOOTER SAVE BUTTON
                goalPreferenceDispatch({
                  type: goalPreferencesActions.UPDATE_CHECKIN_REMINDER_DETAILS,
                });
              }}
              name="Name"
              label="Frequency"
              value={CHECKIN_REMINDER_FREQUENCY.find((freq) => freq.value === recurrencePeriod?.period)}
              options={CHECKIN_REMINDER_FREQUENCY}
              placeholder="Choose a week"
              withBorderBottom
            />
            {recurrencePeriod?.period === 'WEEK' && (
              <SelectDashed
                handleChange={(data) => {
                  changeWeekday(data.value);
                  goalPreferenceDispatch({
                    type: goalPreferencesActions.UPDATE_CHECKIN_REMINDER_DETAILS,
                  });
                }}
                name="Name"
                label="Day"
                options={WEEKDAYS}
                value={WEEKDAYS.find((week) => week.value === weeklyRecurrenceDetails?.day)}
                placeholder="Choose an Weekday"
                withBorderBottom
              />
            )}

            {(recurrencePeriod?.period === 'FORTNIGHTLY' || recurrencePeriod?.period === 'MONTH') && (
              <>
                <SelectDashed
                  handleChange={(obj) => {
                    changeMonthlyRecurrenceDetails('weekNumber', obj.value);
                    goalPreferenceDispatch({
                      type: goalPreferencesActions.UPDATE_CHECKIN_REMINDER_DETAILS,
                    });
                  }}
                  name="Name"
                  options={INSTANCE_PERIOD}
                  value={INSTANCE_PERIOD.find((week) => week.value === monthlyRecurrenceDetails?.weekNumber)}
                  placeholder="Choose an Instance"
                  label="Instance"
                  withBorderBottom
                />
                <SelectDashed
                  handleChange={(obj) => {
                    changeMonthlyRecurrenceDetails('dayOfWeek', obj.value);

                    goalPreferenceDispatch({
                      type: goalPreferencesActions.UPDATE_CHECKIN_REMINDER_DETAILS,
                    });
                  }}
                  name="Name"
                  label="Day"
                  options={WEEKDAYS}
                  value={WEEKDAYS.find((week) => week.value === monthlyRecurrenceDetails?.dayOfWeek)}
                  placeholder="Choose an Weekday"
                  withBorderBottom
                />
              </>
            )}
          </Flex>
        </Box>
      </Box>
      <Box paddingBottom="8rem" />
    </>
  );
};

export default CheckinReminder;
